export default __webpack_public_path__ + "static/media/IMG_5546.24520a71.jpg";